import Vue from 'vue'
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n'
import messages from './langs/languages'
import { getCookie } from '../config/cookie';

Vue.use(VueI18n)
var DefaultLanguage = 'enUS';
let syslang = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
let en = "en"; //英语
let zh = "zh"; //汉语
let de = "de"; //德语
let es = "es"; //西班牙语
let ko = "ko"; //朝鲜语
let ja = "ja"; //日语
let th = "th"; //泰语
// let ar = "ar"; //阿拉伯语
// let ru = "ru"; //俄语
// let fr = "fr"; //法语
// let la = "la"; //拉丁语
// let pt = "pt"; //葡萄牙语
// let it = "it"; //意大利语
// let hi = "hi"; //印地语
// let yi = "yi"; //意第绪语

if (syslang == en || syslang.startsWith("en")){
    DefaultLanguage = "enUS"
} else if (syslang == zh || syslang.startsWith("zh")) {
    DefaultLanguage = "zhCN"
} else if (syslang == de || syslang.startsWith("de")) {
    DefaultLanguage = "deDE"
} else if (syslang == es || syslang.startsWith("es")) {
    DefaultLanguage = "esES"
} else if (syslang == ko || syslang.startsWith("ko")) {
    DefaultLanguage = "koKR"
} else if (syslang == ja || syslang.startsWith("ja")) {
    DefaultLanguage = "jaJP"
} else if (syslang == th || syslang.startsWith("th")) {
    DefaultLanguage = "thTH"
} else {
    DefaultLanguage = "enUS"
}


const i18n = new VueI18n({
//   locale: localStorage.lang || 'enUS',
    locale: getCookie("PLAY_LANG", DefaultLanguage),
    messages
})
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

export default i18n




// WEBPACK FOOTER //
// ./src/i18n/i18n.js